import PropTypes from 'prop-types';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
// universe
import { UNIVERSE_FONT, accentOf, tabularSx } from 'src/theme/universe/brand';

// ----------------------------------------------------------------------
// ONE OF LINGOYOU'S FIGURES under a shared folder (+200 languages, 24/7,
// 20K translators): the figure in the brand's ink, its word small and spaced
// beneath it — on the page's own ground, no band of colour behind it
// (29/10/2026, the simple page).

AnalyticsWidgetSummary.propTypes = {
  sx: PropTypes.object,
  title: PropTypes.string,
  total: PropTypes.string
};

export default function AnalyticsWidgetSummary({ title, total, sx, ...other }) {
  const theme = useTheme();
  return (
    <Box sx={{ minWidth: 0, ...sx }} {...other}>
      <Typography
        component="div"
        sx={{
          fontFamily: UNIVERSE_FONT,
          fontSize: { xs: 22, sm: 26 },
          fontWeight: 700,
          lineHeight: 1.1,
          letterSpacing: '-0.02em',
          color: accentOf(theme),
          ...tabularSx
        }}
      >
        {total}
      </Typography>
      <Typography
        component="div"
        sx={{
          mt: 0.5,
          fontFamily: UNIVERSE_FONT,
          fontSize: { xs: 10, sm: 11 },
          fontWeight: 600,
          lineHeight: 1.35,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: 'text.secondary'
        }}
      >
        {title}
      </Typography>
    </Box>
  );
}
